var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pdf',{attrs:{"src":"../../../public/HODOServicesAgreementWS/HODOWorkspaceServiceAgreementWorkspace.pdf"}})
}
var staticRenderFns = []

export { render, staticRenderFns }